/* ============================================================
 * Standard No More — custom JS
 * Converts the product-page accordion into horizontal tabs
 * (Horizon ships only vertical accordions; the reference uses tabs).
 * ============================================================ */
(function () {
  function buildTabs(scope) {
    var root = scope || document;
    var accordions = root.querySelectorAll('.product-information .accordion');
    Array.prototype.forEach.call(accordions, function (acc) {
      if (acc.dataset.snmTabbed === '1') return;
      var rows = Array.prototype.slice.call(acc.querySelectorAll('accordion-custom'));
      if (rows.length < 2) return;

      acc.dataset.snmTabbed = '1';
      acc.classList.add('snm-tabbed');

      var bar = document.createElement('div');
      bar.className = 'snm-tab-bar';

      rows.forEach(function (row, i) {
        var details = row.querySelector('details');
        var summary = row.querySelector('summary');
        if (details) details.open = true;
        var label = summary ? summary.textContent.trim() : 'Tab ' + (i + 1);

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'snm-tab';
        btn.textContent = label;
        btn.addEventListener('click', function () {
          Array.prototype.forEach.call(bar.querySelectorAll('.snm-tab'), function (b) {
            b.classList.remove('active');
          });
          rows.forEach(function (r) { r.classList.remove('snm-active'); });
          btn.classList.add('active');
          row.classList.add('snm-active');
        });
        bar.appendChild(btn);

        if (i === 0) {
          btn.classList.add('active');
          row.classList.add('snm-active');
        }
      });

      acc.insertBefore(bar, acc.firstChild);
    });
  }

  if (document.readyState !== 'loading') {
    buildTabs();
  } else {
    document.addEventListener('DOMContentLoaded', function () { buildTabs(); });
  }

  // Re-run when a section is re-rendered in the theme editor / dev reload
  document.addEventListener('shopify:section:load', function (e) { buildTabs(e.target); });
})();
